// Loading.tsx
// copyright (c) 2024-present Henrik Bechmann, Toronto, All rights reserved

import React from 'react'
import {
    Box,
} from '@chakra-ui/react'

const Loading = (props) => {
    return <Box minHeight = '100px'> Loading...</Box>
}

export default Loading